import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import loadable from '@loadable/component';
import moment from 'moment';
import queryString from 'query-string';
import cx from 'classnames';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ascend from 'ramda/src/ascend';
import filter from 'ramda/src/filter';
import find from 'ramda/src/find';
import isNil from 'ramda/src/isNil';
import pathEq from 'ramda/src/pathEq';
import propEq from 'ramda/src/propEq';
import prop from 'ramda/src/prop';
import sort from 'ramda/src/sort';
import Avatar from '@components/@core/Avatar';
import DatePicker from '@components/@core/DatePicker';
import ErrorBoundary from '@components/@core/ErrorBoundary';
import EditDropdown from '@components/EditDropdown';
import Filter from '@components/@core/Filter';
import ProgressBar from '@components/@core/ProgressBar';
import Rating from '@components/@core/Rating';
import AppActions from '~/actions/app';
import CompanyActions from '~/actions/company';
import ManageActions from '~/actions/manage';
import withNavigate from '~/hocs/withNavigate';
import DailyScorecard from './DailyScorecard';
import EmployeeComments from './EmployeeComments';
import Task from '../TasksProjects/Task';
const PdfIcon = loadable(() => import('./DailyCheckoutPdf'), { ssr: false });

class DailyCheckoutDetail extends Component {
    constructor(props) {
        super(props);

        const values = queryString.parse(props.location?.search || '');
        const dateStart = new Date(values.date || new Date());
        const completed = props.data?.checkout?.status === 2;
        const users = [...(props.companyCheckouts?.users || []), ...(props.users?.map((e) => ({ user: e })) || [])];

        const companyId = props.data?.checkout?.company_id || props.companyId || 0;
        const company = find(propEq('id', companyId), props.companies || []) || {};
        const roles = company.job_roles || [];

        const id = Number(props.match?.params?.id || props.params?.id);
        const userCheckout = find(pathEq(['user', 'id'], id), users);
        let user = userCheckout?.user || { profile: {} };
        const job = find(propEq('id', user.job_role_id), roles) || {};
        user = { ...user, job };

        this.state = {
            user,
            companyId,
            roles,
            selectedDay: moment(dateStart).utc(),
            completed,
            files: [],
            showPrint: false,
        };
    }

    componentDidMount() {
        const { companyId, selectedDay } = this.state;
        const { companyprojectsRequest, companyProjects, selectprojectRequest } = this.props;
        const id = Number(this.props.match?.params?.id || this.props.params?.id);
        const date = moment(selectedDay).format('YYYY-MM-DD');
        const payload = { user_id: [id], company_id: companyId, date };
        this.props.fetchCheckout(payload);
        this.props.getSubscriptionReports();
        companyprojectsRequest([companyId], [id]);
        const project = companyProjects?.find((item) => item.id === 0);
        selectprojectRequest(project, [id]);
    }

    handleDate = (e) => {
        const { user, companyId } = this.state;
        this.props.fetchPrevious(this.props.data.checkout.id, user.id, {
            dateStart: moment(e).format('YYYY-MM-DD'),
            dateEnd: moment(e).format('YYYY-MM-DD'),
        });
        this.props.fetchCheckout({
            user_id: user.id,
            company_id: companyId,
            date: moment(e).format('YYYY-MM-DD'),
        });
        this.setState({ selectedDay: e });
    };

    handleFilter = (type, e) => {
        const { companyId, roles, selectedDay } = this.state;
        if (type === 'employee') {
            if (e[0].id < 0) return;
            const user = e[0];
            const job = find(propEq('id', user.job_role_id), roles) || {};
            this.props.fetchCheckout({
                user_id: e[0].id,
                company_id: companyId,
                date: moment(selectedDay).format('YYYY-MM-DD'),
            });
            this.setState({ user: { ...user, job } });
        } else {
            this.props.fetchCheckout({
                user_id: this.state.user.id,
                company_id: e[0].id,
                date: moment(selectedDay).format('YYYY-MM-DD'),
            });
            this.setState({ companyId: e[0].id });
        }
    };

    handleActualModal = () => {
        const { data } = this.props;
        const { user, companyId, selectedDay } = this.state;
        const completed = data.checkout.status === 1;

        if (completed) return;

        const payload = {
            type: 'Save Daily Actuals',
            data: {
                before: {
                    user,
                    date: moment(selectedDay).format('YYYY-MM-DD'),
                    after: {
                        type: 'GETCHECKOUT_REQUEST',
                        payload: {
                            user_id: user.id,
                            company_id: companyId,
                            date: moment(selectedDay).format('YYYY-MM-DD'),
                        },
                    },
                },
            },
        };
        this.props.toggleModal(payload);
    };

    handleCheckout = (comment) => {
        const { data } = this.props;
        const { actuals, total } = data?.checkout?.data?.daily_quota_stats ?? {};
        if (actuals !== total) {
            toast.warn(`All quotas actuals must be saved to checkout`, {
                position: toast.POSITION.TOP_RIGHT,
                pauseOnFocusLoss: false,
                hideProgressBar: true,
            });
            return;
        }
        const payload = {
            checkout: {
                id: data.checkout.id,
            },
            comment,
        };
        this.props.completeCheckout(payload);
    };

    handleReset = () => {
        const { data } = this.props;
        const { user, companyId, selectedDay } = this.state;
        const payload = {
            checkout: {
                id: data.checkout.id,
            },
        };
        const after = {
            type: 'GETCHECKOUT_REQUEST',
            payload: {
                user_id: user.id,
                company_id: companyId,
                date: moment(selectedDay).format('YYYY-MM-DD'),
            },
        };
        this.props.resetCheckout(payload, after);
    };

    handleComment = (comment) => {
        const { data } = this.props;
        const payload = {
            checkout: {
                id: data.checkout.id,
            },
            comment,
        };
        this.props.addComment(payload);
        this.props.navigate(-1);
    };

    getPercentValue = (number, total) => {
        if (!total) {
            return '100';
        }
        return (((number ?? 0) / total) * 100).toFixed(0);
    };

    handleReportMenu = (e) => {
        const { user, selectedDay } = this.state;

        switch (e) {
            case 'print':
                this.setState({ showPrint: true });
                break;

            case 'subscribe':
                this.props.toggleModal({
                    type: 'Subscription',
                    data: {
                        before: {
                            name: 'Daily Checkout',
                            user: user,
                            date: selectedDay,
                        },
                    },
                });
                break;

            case 'reset status':
                this.props.toggleModal({
                    type: 'Confirm',
                    data: {
                        before: {
                            title: 'Reset Status',
                            warning: false,
                            body: 'Are you sure you want to Reset the status of this checkout as incomplete?',
                        },
                    },
                    callBack: {
                        onYes: () => {
                            this.handleReset();
                        },
                    },
                });
                break;
        }
    };

    render() {
        const { user, selectedDay } = this.state;
        const { community, data, selectedProjectTasks } = this.props;
        const { checkout, daily_scorecard } = data || {};
        const userName = `${user.profile?.first_name || ''} ${user.profile?.last_name || ''}`;

        const completed = checkout?.status === 1 || checkout?.status === 3;

        const { tasks } = selectedProjectTasks || {};

        const completedTasks = sort(
            ascend(prop('completed_at')),
            filter((x) => {
                const isBefore = moment(x.completed_at).isBefore(moment().startOf('day'));
                return x.status === 3 && !isBefore;
            }, tasks || [])
        );

        const dueTasks = sort(
            ascend(prop('due_at')),
            filter((x) => {
                return x.status !== 3 && x.user_id === user.id;
            }, tasks || [])
        );

        return (
            <ErrorBoundary className="daily-checkout-detail">
                <Filter back="Back" onChange={this.handleFilter} />
                <div className="card mt-2 mt-md-0">
                    <div className="d-flex jc-between mt-3 mt-md-0">
                        <div className="d-flex">
                            <span className="dsl-b22 bold">{userName} Checkout</span>
                        </div>
                        <div className="d-flex d-h-end">
                            <DatePicker
                                className="mt-1 mt-md-0"
                                calendar="day"
                                append="caret"
                                format="MMM DD, YY"
                                as="span"
                                align="right"
                                value={selectedDay}
                                maxDate={new Date()}
                                onSelect={this.handleDate}
                            />
                            <EditDropdown className="ml-3" dataCy="editDropdown" options={completed ? ['Print', 'Subscribe', 'Reset Status'] : ['Print']} onChange={this.handleReportMenu} />
                            {this.state.showPrint && <PdfIcon state={this.state} props={this.props} name="Print" />}
                        </div>
                    </div>
                    <div className="mt-4 d-flex ssm-column">
                        <div className="preview-image mb-2">
                            <Avatar name={userName} slug={community?.entity?.slug} url={user?.avatar || user?.community_user?.avatar} size="large" />
                        </div>
                        <div className="checkout-cards">
                            <div className={cx('checkout-card mb-2', checkout?.data?.tasks_due !== 0 && checkout?.data?.tasks_completed < checkout?.data?.tasks_due && 'warning')}>
                                <p className="dsl-m12 text-400 mb-2">Tasks Completed</p>
                                <p className="dsl-b16 text-400 mb-1">
                                    {checkout?.data?.tasks_completed ?? 0} / {checkout?.data?.tasks_due ?? 0}
                                </p>
                                <div className="dsl-b16 text-400 mb-0">
                                    <ProgressBar value={this.getPercentValue(checkout?.data?.tasks_completed, checkout?.data?.tasks_due)} />
                                </div>
                            </div>
                            <div className={cx('checkout-card mb-2', checkout?.data?.courses_due !== 0 && checkout?.data?.courses_completed < checkout?.data?.courses_due && 'warning')}>
                                <p className="dsl-m12 text-400 mb-2">Courses Completed</p>
                                <p className="dsl-b16 text-400 mb-1">
                                    {checkout?.data?.courses_completed ?? 0} / {checkout?.data?.courses_due ?? 0}
                                </p>
                                <div className="dsl-b16 text-400 mb-0">
                                    <ProgressBar value={this.getPercentValue(checkout?.data?.courses_completed, checkout?.data?.courses_due)} />
                                </div>
                            </div>
                            <div
                                className={cx(
                                    'checkout-card mb-2',
                                    daily_scorecard?.quota_stats?.total !== 0 && daily_scorecard?.quota_stats?.actuals < daily_scorecard?.quota_stats?.total && 'warning'
                                )}
                            >
                                <p className="dsl-m12 text-400 mb-2">Daily Goals Completed</p>
                                {isNil(daily_scorecard?.quota_stats) ? (
                                    <p className="dsl-b16 text-400 mb-3">Not Assigned</p>
                                ) : (
                                    <>
                                        <p className="dsl-b16 text-400 mb-1">
                                            {daily_scorecard?.quota_stats?.actuals ?? 0} / {daily_scorecard?.quota_stats?.total ?? 0}
                                        </p>
                                        <div className="dsl-b16 text-400 mb-0">
                                            <ProgressBar value={this.getPercentValue(daily_scorecard?.quota_stats?.actuals, daily_scorecard?.quota_stats?.total)} />
                                        </div>
                                    </>
                                )}
                            </div>
                            <div className={cx('checkout-card mb-2', !isNil(daily_scorecard) && checkout?.data?.score < 2 && 'warning')}>
                                <p className="dsl-m12 text-400 mb-2">Daily Score</p>
                                {isNil(daily_scorecard) ? (
                                    <p className="dsl-b16 text-400 mb-3">Not Assigned</p>
                                ) : (
                                    <div className="d-flex ai-center mb-3 daily-rating">
                                        {!completed ? (
                                            <p className="dsl-b16 text-400">Incomplete</p>
                                        ) : checkout?.data?.score === 'N/A' ? (
                                            <p className="dsl-b16 text-400">Na Score</p>
                                        ) : (
                                            <Rating score={checkout?.data?.score} />
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                <Row>
                    <Col>
                        <DailyScorecard
                            scorecard={daily_scorecard}
                            userId={user.id}
                            date={selectedDay}
                            avgscore={checkout?.data?.score}
                            dayoff={checkout?.status === 3}
                            onDailyActuals={this.handleActualModal}
                        />
                    </Col>
                    <Col className="d-flex flex-column">
                        {!completed ? (
                            <div className="card h-100 mb-0">
                                <EmployeeComments comments={checkout.data?.comments} onCheckout={this.handleCheckout} onComment={this.handleComment} />
                            </div>
                        ) : (
                            <>
                                <div className="card d-flex-1">
                                    <EmployeeComments completed={completed} comments={checkout.data?.comments} />
                                </div>
                                <div className="card d-flex-1 mb-0">
                                    <p className="dsl-b20 bold">Checkout Details</p>
                                    <div className="h-100 d-flex flex-column border-top border-bottom">
                                        <div>
                                            <p className="dsl-b16 mt-3">{checkout.data?.signoff?.name || checkout.data?.skip?.name} checked out</p>
                                            <p className="dsl-b16">{moment(checkout.data?.signoff?.time || checkout.data?.skip?.time).format('MMM DD, YYYY HH:mm a')}</p>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                    </Col>
                </Row>
                <Row className="mt-2 d-flex flex-column-reverse flex-md-row">
                    <Col>
                        <Task title="Tasks due, incomplete" data={dueTasks} completed={completed} />
                    </Col>
                    <Col>
                        <Task title="Tasks completed today" data={completedTasks} completed={completed} />
                    </Col>
                </Row>
            </ErrorBoundary>
        );
    }
}

const mapStateToProps = (state) => ({
    role: state.app.app_role_id,
    community: state.app.user.community_user,
    userId: state.app.id,
    companies: state.app.companies,
    companyId: state.app.selectedCompany,
    users: state.app.users,
    data: state.manage.dailyCheckout,
    companyCheckouts: state.manage.companyDailyCheckouts,
    companyProjects: state.manage.companyProjects,
    selectedProjectTasks: state.manage.selectedProjectTasks,
});

const mapDispatchToProps = (dispatch) => ({
    fetchCheckout: (e) => dispatch(ManageActions.getcheckoutRequest(e)),
    fetchPrevious: (id, userId, e) => dispatch(ManageActions.getpreviousreviewtasksRequest(id, userId, e, false)),
    addComment: (e) => dispatch(ManageActions.postaddcheckoutcommentRequest(e)),
    completeCheckout: (e) => dispatch(ManageActions.postcheckoutsignoffRequest(e)),
    resetCheckout: (e, after) => dispatch(ManageActions.postcheckoutresetRequest(e, after)),
    toggleModal: (e) => dispatch(AppActions.modalRequest(e)),
    companyprojectsRequest: (companyIds, userIds) => dispatch(ManageActions.companyprojectsRequest(companyIds, userIds)),
    selectprojectRequest: (project, userIds) => dispatch(ManageActions.selectprojectRequest(project, userIds)),
    getSubscriptionReports: () => dispatch(CompanyActions.getsubscriptionreportsRequest(false)),
});

const DailyCheckoutDetailWithNavigate = withNavigate(DailyCheckoutDetail);

export default connect(mapStateToProps, mapDispatchToProps)(DailyCheckoutDetailWithNavigate);
